// logic
import { push } from 'connected-react-router';
import routes from 'utils/routes';
// state
import { useSelector, useDispatch } from 'react-redux';
import reducerUtils from 'state/utils';
import {
  actions as analyticsActions,
  constants as analyticsEvents,
} from 'state/analytics';
import { selectors as authSelectors } from 'state/auth';
import { actions as orderActions } from 'state/order';
import useShowNewSoForm from 'refactored/features/soForm/useShowNewSoForm';

const useNewOrderButton = () => {
  const dispatch = useDispatch();
  const showNewForm = useShowNewSoForm();

  const isValidToMakeOrders = useSelector(
    authSelectors.getPaymentDataAllowShipperDoShipments
  );

  const isNewOrderButtonDisabled = showNewForm
    ? window.location.pathname === routes.newOrderCatalog
    : window.location.pathname === routes.newOrder;

  const onNewOrderButtonClick = () => {
    dispatch(
      analyticsActions.sendEvent(
        analyticsEvents.orders.list.orderTypeChosen({ type: 'spot' })
      )
    );
    dispatch({ type: reducerUtils.RESET_ORDER_STATE });
    if (isValidToMakeOrders) {
      dispatch(orderActions.setRecurring({ isRecurring: false }));
      const routeToRedirect = showNewForm
        ? routes.newOrderCatalog
        : routes.newOrder;
      dispatch(push(routeToRedirect));
    } else {
      dispatch(orderActions.checkPaymentMethod());
    }
  };

  return {
    isNewOrderButtonDisabled,
    onNewOrderButtonClick,
  };
};

export default useNewOrderButton;
